import Content, { ContentNS } from "content/content";
import useItemLevelAnalytics from "features/shared/hooks/analytics/useItemLevelAnalytics";
import useItemLevelRedirect from "features/shared/hooks/navigation/useItemLevelRedirect";
import useNavigateWithQuery from "features/shared/hooks/navigation/useNavigateWithQuery";
import Body from "features/shared/styles/typography/Body.styled";
import { Summary } from "features/shared/styles/typography/Summary.styled";
import { FC, useEffect } from "react";
import { DocProcessingStatus } from "models/doc-processing-status";
import { useAppStore } from "store/store";

import ProcessingAnimation from "../shared/styles/ProcessingAnimation.styled";
// @ts-expect-error - This is how we utilize dynamic imports with WebPack NormalModuleReplacementPlugin
import ProcessingCard from "./styles/ProcessingCard-APP_CLIENT.styled";
import useItemLevelNavigationState from "features/shared/hooks/navigation/useItemLevelNavigationState";
import { useSearchParams } from "react-router-dom";

const DocumentProcessing: FC = () => {
  useItemLevelAnalytics();

  const status = useAppStore((state) => state.processingStatus);
  const fileName = useAppStore((state) => state.processedFileName);

  const processingMayTakeLong = useAppStore(
    (state) => state.processingMayTakeLong
  );

  const text = (s: string) => Content.shared.t(s, { ns: ContentNS.checklist });

  const navigate = useNavigateWithQuery();

  const [searchParams] = useSearchParams();
  const itemLevelNavigationState = useItemLevelNavigationState(searchParams);

  const navigateToItemPage = useItemLevelRedirect(itemLevelNavigationState);

  useEffect(() => {
    if (status === DocProcessingStatus.Ineligible) {
      navigate("/ineligible");
    }

    if (status === DocProcessingStatus.Error) {
      navigateToItemPage();
    }

    if (status === DocProcessingStatus.Success) {
      navigate("../../checklist");
    }
  }, [navigate, navigateToItemPage, status]);

  let title = text("processing.idle");

  if (status === DocProcessingStatus.InProgress) {
    title = text("processing.in-progress");

    return (
      <ProcessingCard>
        <Summary>{title}</Summary>

        {status === DocProcessingStatus.InProgress ? (
          <>
            {fileName ? <Body className="file-name">{fileName}</Body> : null}
            <ProcessingAnimation />
            {processingMayTakeLong && (
              <div style={{ marginTop: "1rem" }}>
                <Body>{text("processing.in-progress-long-warning")}</Body>
              </div>
            )}
          </>
        ) : null}
      </ProcessingCard>
    );
  }

  return null;
};

export default DocumentProcessing;
